import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface SaveBeforeLockDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** What is staged on the route, e.g. "1 stop added", or "" for times alone. */
  stagedSummary: string
  onSave: () => void
  onDiscard: () => void
}

export default function SaveBeforeLockDialog({
  open,
  onOpenChange,
  stagedSummary,
  onSave,
  onDiscard,
}: SaveBeforeLockDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unsaved Changes</AlertDialogTitle>
          <AlertDialogDescription>
            You have made changes to this route's stop schedule
            {stagedSummary ? ` (${stagedSummary})` : ""}. Would you like to save these changes
            before locking the route?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={onDiscard}
            className="bg-palette-jungleGreen100 text-palette-jungleGreen700 hover:bg-palette-jungleGreen200"
          >
            Discard Changes
          </AlertDialogCancel>
          <AlertDialogAction onClick={onSave} variant="confirm">
            Save & Lock
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
